import {
  ADD_NOTIFICATION,
  GET_NOTIFICATIONS,
  SEND_NOTIFICATION,
  RESEND_NOTIFICATION,
  TEST_NOTIFICATION,
  GET_REPLIES,
  SET_REPLY_CUSTOMER_INFO,
  STOP_SEND_PROCESS,
  UNSUBSCRIBE_CUSTOMER,
  SUBSCRIBE_CUSTOMER,
  MARK_AS_READ,
  GET_CUSTOMERS_FOR_GRID,
  GET_NOTIFICATION_MESSAGES,
  SEND_MESSAGES_TO_GRID,
  ADD_AUTO_UNSUBSCRIBE_KEYWORD,
  GET_AUTO_UNSUBSCRIBE_KEYWORDS,
  UPDATE_AUTO_UNSUBSCRIBE_KEYWORD,
  DELETE_AUTO_UNSUBSCRIBE_KEYWORD,
} from "../actions";

const initialState = {
  addNotification: null,
  testNotification: null,
  sendIndividualNotification: null,
  resendNotification: null,
  notifications: [],
  replies: [],
  replyCustomer: null,
  stopSending: null,
  subscribeCustomer: null,
  unsubscribeCustomer: null,
  markRead: null,
  customersForGrid: [],
  notificationMessages: [],
  messageToGrid: null,
  addUnsubscirbeKeyword: null,
  getUnsubscribeKeywords: [],
  updateUnsubscribeKeyword: null,
  deleteUnsubscribeKeyword: null,
  addNotificationError: null,
  testNotificationError: null,
  resendNotificationError: null,
  notificationsError: null,
  repliesError: null,
  stopSendingError: null,
  subscribeCustomerError: null,
  unsubscribeCustomerError: null,
  markReadError: null,
  sendIndividualNotificationError: null,
  customersForGridError: null,
  notificationMessagesError: null,
  messageToGridError: null,
  addUnsubscirbeKeywordError: null,
  getUnsubscribeKeywordsError: null,
  updateUnsubscribeKeywordError: null,
  deleteUnsubscribeKeywordError: null,
};

function notificationManagerReducer(state = initialState, action) {
  let addNotification,
    testNotification,
    notifications,
    resendNotification,
    replies,
    replyCustomer,
    stopSending,
    unsubscribeCustomer,
    subscribeCustomer,
    markRead,
    sendIndividualNotification,
    customersForGrid,
    notificationMessages,
    messageToGrid,
    addUnsubscirbeKeyword,
    getUnsubscribeKeywords,
    updateUnsubscribeKeyword,
    deleteUnsubscribeKeyword;

  switch (action.type) {
    case `${ADD_NOTIFICATION}_PENDING`:
    case `${TEST_NOTIFICATION}_PENDING`:
    case `${GET_NOTIFICATIONS}_PENDING`:
    case `${RESEND_NOTIFICATION}_PENDING`:
    case `${GET_REPLIES}_PENDING`:
    case `${STOP_SEND_PROCESS}_PENDING`:
    case `${UNSUBSCRIBE_CUSTOMER}_PENDING`:
    case `${SUBSCRIBE_CUSTOMER}_PENDING`:
    case `${MARK_AS_READ}_PENDING`:
    case `${SEND_NOTIFICATION}_PENDING`:
    case `${GET_CUSTOMERS_FOR_GRID}_PENDING`:
    case `${GET_NOTIFICATION_MESSAGES}_PENDING`:
    case `${SEND_MESSAGES_TO_GRID}_PENDING`:
    case `${ADD_AUTO_UNSUBSCRIBE_KEYWORD}_PENDING`:
    case `${GET_AUTO_UNSUBSCRIBE_KEYWORDS}_PENDING`:
    case `${UPDATE_AUTO_UNSUBSCRIBE_KEYWORD}_PENDING`:
    case `${DELETE_AUTO_UNSUBSCRIBE_KEYWORD}_PENDING`:
      return {
        ...state,
        loading: true,
        addNotificationError: null,
        notificationsError: null,
        resendNotificationError: null,
        repliesError: null,
        stopSendingError: null,
        unsubscribeCustomerError: null,
        subscribeCustomerError: null,
        markReadError: null,
        sendIndividualNotificationError: null,
        customersForGridError: null,
        notificationMessagesError: null,
        messageToGridError: null,
        addUnsubscirbeKeywordError: null,
        getUnsubscribeKeywordsError: null,
        updateUnsubscribeKeywordError: null,
        deleteUnsubscribeKeywordError: null,
      };

    case `${ADD_NOTIFICATION}_FULFILLED`:
      addNotification = action.payload.data;
      return { ...state, loading: false, addNotification };
    case `${TEST_NOTIFICATION}_FULFILLED`:
      testNotification = action.payload.data;
      return { ...state, loading: false, testNotification };
    case `${RESEND_NOTIFICATION}_FULFILLED`:
      resendNotification = action.payload.data;
      return { ...state, loading: false, resendNotification };
    case `${GET_NOTIFICATIONS}_FULFILLED`:
      notifications = action.payload.data;
      return { ...state, loading: false, notifications };
    case `${GET_REPLIES}_FULFILLED`:
      replies = action.payload.data;
      return { ...state, loading: false, replies };
    case `${SET_REPLY_CUSTOMER_INFO}`:
      replyCustomer = action.payload;
      return { ...state, loading: false, replyCustomer };
    case `${STOP_SEND_PROCESS}_FULFILLED`:
      stopSending = action.payload.data;
      return { ...state, loading: false, stopSending };
    case `${UNSUBSCRIBE_CUSTOMER}_FULFILLED`:
      unsubscribeCustomer = action.payload.data;
      return { ...state, loading: false, unsubscribeCustomer };
    case `${SUBSCRIBE_CUSTOMER}_FULFILLED`:
      subscribeCustomer = action.payload.data;
      return { ...state, loading: false, subscribeCustomer };
    case `${MARK_AS_READ}_FULFILLED`:
      markRead = action.payload.data;
      return { ...state, loading: false, markRead };
    case `${SEND_NOTIFICATION}_FULFILLED`:
      sendIndividualNotification = action.payload.data;
      return { ...state, loading: false, sendIndividualNotification };
    case `${GET_CUSTOMERS_FOR_GRID}_FULFILLED`:
      customersForGrid = action.payload.data;
      return { ...state, loading: false, customersForGrid };
    case `${GET_NOTIFICATION_MESSAGES}_FULFILLED`:
      notificationMessages = action.payload.data;
      return { ...state, loading: false, notificationMessages };
    case `${SEND_MESSAGES_TO_GRID}_FULFILLED`:
      messageToGrid = action.payload.data;
      return { ...state, loading: false, messageToGrid };
    case `${ADD_AUTO_UNSUBSCRIBE_KEYWORD}_FULFILLED`:
      addUnsubscirbeKeyword = action.payload.data;
      return { ...state, loading: false, addUnsubscirbeKeyword };
    case `${GET_AUTO_UNSUBSCRIBE_KEYWORDS}_FULFILLED`:
      getUnsubscribeKeywords = action.payload.data;
      return { ...state, loading: false, getUnsubscribeKeywords };
    case `${UPDATE_AUTO_UNSUBSCRIBE_KEYWORD}_FULFILLED`:
      updateUnsubscribeKeyword = action.payload.data;
      return { ...state, loading: false, updateUnsubscribeKeyword };
    case `${DELETE_AUTO_UNSUBSCRIBE_KEYWORD}_FULFILLED`:
      deleteUnsubscribeKeyword = action.payload.data;
      return { ...state, loading: false, deleteUnsubscribeKeyword };

    case `${ADD_NOTIFICATION}_REJECTED`:
      return { ...state, loading: false, addNotificationError: action.payload.response.data, state: initialState };
    case `${TEST_NOTIFICATION}_REJECTED`:
      return { ...state, loading: false, testNotificationError: action.payload.response.data, state: initialState };
    case `${RESEND_NOTIFICATION}_REJECTED`:
      return { ...state, loading: false, resendNotificationError: action.payload.response.data, state: initialState };
    case `${GET_NOTIFICATIONS}_REJECTED`:
      return { ...state, loading: false, notificationsError: action.payload.response.data, state: initialState };
    case `${GET_REPLIES}_REJECTED`:
      return { ...state, loading: false, repliesError: action.payload.response.data, state: initialState };
    case `${STOP_SEND_PROCESS}_REJECTED`:
      return { ...state, loading: false, stopSendingError: action.payload.response.data, state: initialState };
    case `${UNSUBSCRIBE_CUSTOMER}_REJECTED`:
      return { ...state, loading: false, unsubscribeCustomerError: action.payload.response.data, state: initialState };
    case `${SUBSCRIBE_CUSTOMER}_REJECTED`:
      return { ...state, loading: false, subscribeCustomerError: action.payload.response.data, state: initialState };
    case `${MARK_AS_READ}_REJECTED`:
      return { ...state, loading: false, markReadError: action.payload.response.data, state: initialState };
    case `${SEND_NOTIFICATION}_REJECTED`:
      return {
        ...state,
        loading: false,
        sendIndividualNotificationError: action.payload.response.data,
        state: initialState,
      };
    case `${GET_CUSTOMERS_FOR_GRID}_REJECTED`:
      return { ...state, loading: false, customersForGridError: action.payload.response.data, state: initialState };
    case `${GET_NOTIFICATION_MESSAGES}_REJECTED`:
      return { ...state, loading: false, notificationMessagesError: action.payload.response.data, state: initialState };
    case `${SEND_MESSAGES_TO_GRID}_REJECTED`:
      return { ...state, loading: false, messageToGridError: action.payload.response.data, state: initialState };
    case `${ADD_AUTO_UNSUBSCRIBE_KEYWORD}_REJECTED`:
      return { ...state, loading: false, addUnsubscirbeKeywordError: action.payload.response.data, state: initialState };
    case `${GET_AUTO_UNSUBSCRIBE_KEYWORDS}_REJECTED`:
      return { ...state, loading: false, getUnsubscribeKeywordsError: action.payload.response.data, state: initialState };
    case `${UPDATE_AUTO_UNSUBSCRIBE_KEYWORD}_REJECTED`:
      return { ...state, loading: false, updateUnsubscribeKeywordError: action.payload.response.data, state: initialState };
    case `${DELETE_AUTO_UNSUBSCRIBE_KEYWORD}_REJECTED`:
      return { ...state, loading: false, deleteUnsubscribeKeywordError: action.payload.response.data, state: initialState };
    default:
      return state;
  }
}

export default notificationManagerReducer;
